var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.headline
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm.headline
              ? _c(
                  "h2",
                  { staticClass: "hl hl--2 rtf" },
                  [_vm._t("headline")],
                  2
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.pdfCatalogList, function (catalog) {
        return _c(
          "div",
          {
            staticClass: "col-md-3 col-6 pdf-catalog-teaser__wrapper",
            attrs: {
              "data-tracking-component": "PDF Katalog",
              "data-tracking-page": "Angebote",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "pdf-catalog-teaser",
                attrs: {
                  "data-testing-id": "396c9886-1fba-4051-a325-194e37995175",
                  "data-tracking-name": "efs-2022-kw03-04-hz-a4-gastro-nord",
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "pdf-catalog-teaser__img-anker",
                    attrs: {
                      href: catalog.linkToDownload,
                      "data-pdf-viewer": "",
                      target: "_blank",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "pdf-catalog-teaser__show-icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "30",
                          viewBox: "0 0 24 30",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#FFF",
                            "fill-rule": "evenodd",
                            d: "M24,26.385 L24,9 L15,0 L3,0 C1.34900662,0.00825506997 0.0149793622,1.34898598 0.015,3 L0,27 C-2.06378036e-05,28.651014 1.33400662,29.9917449 2.985,30 L21,30 C21.644296,29.9987029 22.2707338,29.7881355 22.785,29.4 L16.14,22.755 C13.2739774,24.6522904 9.4850716,24.3585816 6.94567916,22.0422737 C4.40628673,19.7259658 3.76640253,15.9799519 5.39290881,12.9520361 C7.01941509,9.92412044 10.4959837,8.38934252 13.8292987,9.22767843 C17.1626137,10.0660144 19.4994642,13.0628797 19.5,16.5 C19.4992934,17.9674569 19.0662664,19.4021848 18.255,20.625 L24,26.385 Z M7.49999598,16.499996 C7.5,18.9852814 9.51471863,21 11.999996,20.999996 C14.4852814,21 16.5,18.9852814 16.499996,16.499996 C16.5,14.0147186 14.4852814,12 11.999996,11.999996 C10.8060375,11.9984049 9.66051785,12.4719984 8.81625811,13.3162581 C7.97199838,14.1605178 7.49840486,15.3060375 7.49999598,16.499996 Z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pdf-catalog-teaser__img-wrapper" },
                      [
                        _c("picture", [
                          _c("source", {
                            attrs: {
                              media: "(min-width: 1440px)",
                              srcset: catalog.image.width640,
                            },
                          }),
                          _vm._v(" "),
                          _c("source", {
                            attrs: {
                              media: "(min-width: 768px)",
                              srcset: catalog.image.width300,
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "pdf-catalog-teaser__img",
                            attrs: {
                              height: "297",
                              width: "210",
                              src: catalog.image.width480,
                              alt: catalog.image.alt,
                              loading: "lazy",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pdf-catalog-teaser__content" }, [
                  _c("div", { staticClass: "pdf-catalog-teaser__headline" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(catalog.headline) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "pdf-catalog-teaser__validity-headline" },
                    [_vm._v("\n              Gültigkeit:\n            ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pdf-catalog-teaser__validity" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.formatValidity(catalog)) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pdf-catalog-teaser__btn-wrapper" }, [
                  _c("div", { staticClass: "pdf-catalog-teaser__show-btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn--ghost btn--w100",
                        attrs: {
                          "data-pdf-viewer": "",
                          href: catalog.linkToDownload,
                          target: "_blank",
                        },
                      },
                      [
                        _c("span", { staticClass: "btn__inner" }, [
                          _vm._v("Ansicht"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pdf-catalog-teaser__download-btn" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn--prim btn--w100",
                          attrs: { download: "", href: catalog.linkToDownload },
                        },
                        [
                          _c("span", { staticClass: "btn__inner" }, [
                            _vm._v("Download"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }